module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-05.cfa29480.jpg";